import CategoryWeightItem from './CategoryWeightItem'

export default CategoryWeightItem
